// import React, { Component } from 'react';
// import { render } from 'react-dom';
// import { withScriptjs, withGoogleMap, GoogleMap, Marker} from 'react-google-maps';

function InformationBox() {
  // get AddressMap() {
  //   const MyMap = withScriptjs(withGoogleMap((props) => 
  //     <GoogleMap
  //       defaultZoom={16}
  //       defaultCenter={{ lat: 53.741330, lng: -2.016268 }}
  //     >
  //       <Marker position={{ lat: 53.741330, lng: -2.016268 }} />
  //     </GoogleMap>
  //   ));

  //   return <MyMap
  //     isMarkerShown
  //     googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDeaRvd7-tQh4c0WqIBQpWutHikYR0k3jY&v=3.exp&libraries=geometry,drawing,places"
  //     loadingElement={<div style={{ height: `100%` }} />}
  //     containerElement={<div style={{ height: `400px` }} />}
  //     mapElement={<div style={{ height: `100%` }} />}
  //   />;
  // }


  return (
    <div className="c-information-box">
      <div className="c-information-box--content">
        <div className="c-information-box--phone">
          <div className="c-information-box--phone__header">
            <p><i className="material-icons">call</i>Phone</p>
          </div>
          <div className="c-information-box--phone__main">
            <p>Call us at <a href="tel:441422842331">01422 842331</a> to order.</p>
          </div>
        </div>
        <div className="c-information-box--address">
          <div className="c-information-box--address__header">
            <p><i className="material-icons">schedule</i>Opening Times</p>
          </div>
          <div className="c-information-box--address__main">
            <div className="c-information-box--address__main--text">
              <p><b>Monday:</b> Closed (including Bank Holiday Mondays)</p>
              <p><b>Tuesday:</b> Closed</p>
              <p><b>Wednesday:</b> 5pm - 9pm</p>
              <p><b>Thursday:</b> 5pm - 9pm</p>
              <p><b>Friday:</b> 5pm - 9pm</p>
              <p><b>Saturday:</b> 5pm - 9pm</p>
              <p><b>Sunday:</b> 5pm - 9pm</p>
            </div>
          </div>
        </div>
        <div className="c-information-box--address">
          <div className="c-information-box--address__header">
            <p><i className="material-icons">home</i>Address</p>
          </div>
          <div className="c-information-box--address__main">
            <div className="c-information-box--address__main--map">
              {/* {this.AddressMap} */}
            </div>
            <div className="c-information-box--address__main--text">
              <p><b>You can find us at:</b></p>
              <p>33 Market Street</p>
              <p>Hebden Bridge</p>
              <p>West Yorkshire</p>
              <p>HX7 6EU</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InformationBox;
